export default __webpack_public_path__ + "locales/sr-Cyrl-RS/People.json?hash=d49281e18f782689b1f1fb5c68080629";